
import * as moment from 'moment';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { RotationTermPhrases } from '../../shared/configuration/BarometerConfig';
import { AnswerType, IAnswerHypermediaRepresentation, Point } from '../../shared/contracts/AnswerContract';
import { ISnapshotHypermediaRepresentation } from '../../shared/contracts/SnapshotContract';
import { stylingService } from '../../shared/services/StylingService';
import Clamped from '../shared/Clamped.vue';

@Component({
    components: {
        Clamped
    }
})
export default class PeopleAction extends Vue {
    @Prop() snapshot: ISnapshotHypermediaRepresentation;

    private answerTypes: AnswerType[] = [AnswerType.Project, AnswerType.Growth, AnswerType.Network, AnswerType.Rotation];
    private answerGroups: { [answerType: string]: IAnswerHypermediaRepresentation[] } = {};
    private rotationTermPhrases = RotationTermPhrases;

    created() {
        this.groupSnapshotAnswers();
    }

    getAnswersActionClass(answers: IAnswerHypermediaRepresentation[], showPositives: boolean = false) {
        if (answers.some(answer => answer.quantitative === Point.Negative)) {
            return 'people-action__content__item__answer--negative';
        }
        if (answers.some(answer => answer.quantitative === Point.Neutral)) {
            return 'people-action__content__item__answer--neutral';
        }
        return showPositives && answers.some(answer => answer.quantitative === Point.Positive)
            ? 'people-action__content__item__answer--positive'
            : '';
    }

    getDateFormatted(dateString: string) {
        return moment(dateString).format('DD-MM-YYYY');
    }

    onPopoverShown() {
        this.answerTypes.forEach((answerType, typeIndex) => {
            this.answerGroups[answerType].forEach((answer, index) => {
                this.checkClamped(`people-action__popover-${typeIndex}-${index}`);
            });
        });
        this.checkClamped('overall-comment');
    }

    getDynamicAgingClass(creationDate: string) {
        const convertedCreationDate = moment(creationDate).startOf('day');
        return stylingService.selectAgeStyle(convertedCreationDate, [
            {
                // [0,1[ months: youngest
                timeInterval: moment.duration(0, 'months'),
                styleClass: 'colored-edge-panel--young'
            },
            {
                // [3,5[ months: old
                timeInterval: moment.duration(3, 'months'),
                styleClass: 'colored-edge-panel--middleaged'
            },
            {
                // [5,6[ months: oldest
                timeInterval: moment.duration(5, 'months'),
                styleClass: 'colored-edge-panel--old'
            },
            {
                // [6,inf[ months: expired
                timeInterval: moment.duration(6, 'months'),
                styleClass: 'colored-edge-panel--expired'
            }
        ]);
    }

    private checkClamped(ref: string) {
        const clampedRef = this.$refs[ref] as Clamped[];
        if (clampedRef && clampedRef.length) {
            clampedRef[0].checkClamped();
        }
    }

    private groupSnapshotAnswers() {
        this.answerTypes.forEach(answerType => {
            this.answerGroups[answerType] = this.snapshot.answers.filter(answer => answer.answerType === answerType);
        });
    }
}
